import script from "./WorkOrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrderView.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrderView.vue?vue&type=style&index=0&id=462158fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462158fb"]])

export default __exports__